import { logPageView } from "@/lib/analytics";
import { useEffect } from "react";
import { useLocation } from "react-router";

/**
 * Componente para rastrear visualizações de página no Google Analytics
 * Este componente deve ser montado uma vez no layout principal da aplicação
 */
export const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Registra a visualização de página sempre que a rota muda
    logPageView(location.pathname + location.search);
  }, [location]);

  // Este componente não renderiza nada visualmente
  return null;
};
